import { render, staticRenderFns } from "./EducationCard.vue?vue&type=template&id=337ae62a"
import script from "./EducationCard.vue?vue&type=script&lang=ts"
export * from "./EducationCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('337ae62a')) {
      api.createRecord('337ae62a', component.options)
    } else {
      api.reload('337ae62a', component.options)
    }
    module.hot.accept("./EducationCard.vue?vue&type=template&id=337ae62a", function () {
      api.rerender('337ae62a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/profile/educations/EducationCard.vue"
export default component.exports